export const GET_DEVICE_REQUEST = 'GET_DEVICE_REQUEST';
export const GET_DEVICE_SUCCESS = 'GET_DEVICE_SUCCESS';
export const GET_DEVICE_FAILURE = 'GET_DEVICE_FAILURE';

export const SET_DEVICE = 'SET_DEVICE';

export const getDeviceRequest = (filters = {}) => ({
    type: GET_DEVICE_REQUEST,
    payload: {
        filters
    }
});

export const getDeviceSuccess = (device) => ({
    type: GET_DEVICE_SUCCESS,
    payload: {
        device
    }
});

export const getDeviceFailure = err => ({
    type: GET_DEVICE_FAILURE,
    error: err
});

export const setDevice = (device = {}) => ({
    type: SET_DEVICE,
    payload: {
        device
    }
});
